import { store } from "@/state/store";

const landingPageContainerID = "LandingPageMediaComponentWrapper"; // -> defined in landingpagemediacomponent.jsp
const langingPageHeaderTextID = "LandingPageHeaderContent"; // -> defined in loginRegistrationForm.jsp and RegistrationForm.jsp

export const initStore = (rootContainerID: string) => {
	const rootContainerData = readRootContainerDataAttr(rootContainerID);
	store.isLastStepPage = rootContainerData.isLastStepPage;
	store.username = rootContainerData.username;
	store.oAuthSignIn = rootContainerData.oAuthSignIn;

	const landingPageData = readLandingpageDataAttr(landingPageContainerID);
	store.isLandingPage = landingPageData.isLandingPage;
	store.landingPage.hasHiResImage = landingPageData.landingPageHasHiResImage;
	store.landingPage.desktopImageURL = landingPageData.landingPageDesktopImageURL;
	store.landingPage.tabletImageURL = landingPageData.landingPageTabletImageURL;
	store.landingPage.mobileImageURL = landingPageData.landingPageMobileImageURL;
	store.landingPage.imageAltText = landingPageData.landingPageImageAltText;

	store.landingPage.headerText = extractLandingpageHeaderText(langingPageHeaderTextID);
};

function readRootContainerDataAttr(rootContainerID: string) {
	const wrapperElement: HTMLElement | null | undefined = document
		.getElementById(rootContainerID)
		?.closest("[data-mfloginwrapper]");

	const username: string = wrapperElement?.dataset.username || "";
	const isLastStepPage: boolean = wrapperElement?.dataset.islaststeppage === "true";
	const oAuthSignIn: string = wrapperElement?.dataset.oauthsignin || "";

	return {
		username,
		isLastStepPage,
		oAuthSignIn,
	};
}

function readLandingpageDataAttr(landingPageContainerID: string) {
	const landingPageImageData = document.getElementById(landingPageContainerID) as HTMLElement;
	const isLandingPage = !!landingPageImageData;

	let landingPageHasHiResImage = false;
	let landingPageDesktopImageURL = "";
	let landingPageTabletImageURL = "";
	let landingPageMobileImageURL = "";
	let landingPageImageAltText = "";

	if (landingPageImageData) {
		if (landingPageImageData.dataset["landingPageImage"]) {
			const image = landingPageImageData.dataset["landingPageImage"];
			landingPageHasHiResImage = true;
			landingPageDesktopImageURL = `${image}?width=1000&height=600&fit=crop&format=auto 1x, ${image}?width=2000&height=1200&fit=crop&format=auto 2x`; // Aspect ratio 5:3
			landingPageTabletImageURL = `${image}?width=800&height=360&fit=crop&format=auto 1x, ${image}?width=1600&height=720&fit=crop&format=auto 2x`; // Aspect ratio 20:9
			landingPageMobileImageURL = `${image}?width=400&height=180&fit=crop&format=auto 1x, ${image}?width=800&height=360&fit=crop&format=auto 2x`; // Aspect ratio 20:9
			landingPageImageAltText = landingPageImageData.dataset["landingPageAltText"] || "";
		} else {
			landingPageHasHiResImage = false;
			landingPageDesktopImageURL = landingPageImageData.dataset["desktopImage"] || "";
			landingPageTabletImageURL = landingPageImageData.dataset["mobileImage"] || "";
			landingPageMobileImageURL = landingPageImageData.dataset["mobileImage"] || "";
			landingPageImageAltText = landingPageImageData.dataset["desktopAltText"] || "";
		}
	}

	return {
		isLandingPage,
		landingPageHasHiResImage,
		landingPageDesktopImageURL,
		landingPageTabletImageURL,
		landingPageMobileImageURL,
		landingPageImageAltText,
	};
}

function extractLandingpageHeaderText(landingPageHeaderContentID: string) {
	const headerContent = document.getElementById(landingPageHeaderContentID);
	let landingPageHeaderText = "";
	if (headerContent) {
		landingPageHeaderText = headerContent.querySelector("h2")?.textContent || "";
	}
	return landingPageHeaderText;
}
